itsoftApp.createModule("animateScroll", ["windowResize"], function () {
    var maxMobileWidth = 767;
    var module = this;
    var loaded = false;
    var pageHeader = document.querySelector("[data-fixed='true']"); /* есть ли фиксированная шапка */
    var viewportSize = itsoftApp.utils.getViewportSize(); /* определяем текущий вьюпорт */
    var scroll;

    var getViewportSize = function () {
        viewportSize = itsoftApp.utils.getViewportSize();
    };

    var startScroll = function (target, padding, speed, speedAsDuration) {
        var defaultPadding = 0;

          /* вычисляет отступ сверху */
        if (pageHeader) {
            if (!itsoftApp.commonVars.headerHeight) {
                itsoftApp.utils.getHeaderHeight(); /* берём высоту шапки */
            }

            if (target.hasAttribute("data-offset")) {
                if (viewportSize <= maxMobileWidth) {
                    defaultPadding = itsoftApp.commonVars.headerHeight * 1.25;
                } else {
                    defaultPadding = itsoftApp.commonVars.headerHeight + itsoftApp.commonVars.headerHeight / 5;
                }
            } else if (target.hasAttribute("data-offset-mobile") && viewportSize <= maxMobileWidth) {
                defaultPadding = itsoftApp.commonVars.headerHeight * 1.5;
            } else {
                defaultPadding = itsoftApp.commonVars.headerHeight;
            }
        }

          /* добавляем отступ сверху, если, например, есть фиксированная шапка */
        var settings = {
            offset: defaultPadding
        };

          /* вычисляем скорость и время, за которое произойдёт прокрутка */

        if (speed) {
            settings.speed = speed;
        }

        if (speedAsDuration) {
            settings.speedAsDuration = speedAsDuration;
        }

          /* Уничтожаем предыдущий экземпляр, если он есть */
        if (scroll) {
            scroll.destroy();
            scroll = "";
        }
          
        scroll = new SmoothScroll();

        if (!document.body.classList.contains("is-popup-opened")) {
            setTimeout(function () {
                scroll.animateScroll(target, "auto", settings);
            }, 100);
        } else {
            setTimeout(function () {
                scroll.animateScroll(target, "auto", settings);
            }, 800);
        }
    };

    /* доработка активной ссылки при скролле до блока на главной странице */
    
    let pageWithLinks = document.querySelector('.page__main--goto-block');

    if (pageWithLinks) {
        let goToLink = document.querySelectorAll('._goto-block');

        if (goToLink) {
            let blocks = [];
            for (let index = 0; index < goToLink.length; index++) {
                let el = goToLink[index];
                let block_name = el.getAttribute('href').replace('#', '');
                if (block_name != '' && !~blocks.indexOf(block_name)) {
                    blocks.push(block_name);
                }
            }
        
            window.addEventListener('scroll', function (el) {
                let old_current_link = document.querySelectorAll('._goto-block._active');
                if (old_current_link) {
                    for (let index = 0; index < old_current_link.length; index++) {
                        let el = old_current_link[index];
                        el.classList.remove('_active');
                    }
                }
                for (let index = 0; index < blocks.length; index++) {
                    let block = blocks[index];
                    let block_item = document.querySelector('.' + block);
                    if (block_item) {
                        let block_offset = offsetGoTo(block_item).top;
                        let block_height = block_item.offsetHeight;
                        if ((pageYOffset > block_offset - window.innerHeight / 5) && pageYOffset < (block_offset + block_height) - window.innerHeight / 5) {
                            let current_links = document.querySelectorAll('._goto-block[href="#' + block + '"]');
                            for (let index = 0; index < current_links.length; index++) {
                                let current_link = current_links[index];
                                current_link.classList.add('_active');
                            }
                        }
                    }
                }
                function offsetGoTo(el) {
                    var rect = el.getBoundingClientRect(),
                        scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
                        scrollTop = window.pageYOffset || document.documentElement.scrollTop;
                    return { top: rect.top + scrollTop, left: rect.left + scrollLeft }
                }
            })
        };
    }

    /* доработка активной ссылки при скролле до блока на главной странице */

    var load = function (target, padding, speed, speedAsDuration) {
      /* если библиотека для плавной анимации пока не загружена, загружаем... */
        if (!loaded) {
            itsoftApp.loadScript("/assets/scripts/smoothScroll/smooth-scroll.min.js", function () {
                loaded = true;
                startScroll(target, padding, speed, speedAsDuration);
            });
        } else {
            // иначе сразу запускаем функцию
            startScroll(target, padding, speed, speedAsDuration);
        }
    };

    var initAnimateScroll = function (el) { // el, padding
        el.addEventListener("click", function (evt) {
            evt.preventDefault();
            var scrollId = evt.currentTarget.href;
          
            if (!scrollId || !(scrollId = scrollId.split("#")[1])) {
                return;
            }

            /* Находим элемент, до которого нуңно прокрутить страницу, и передаём его в функцию */
            var target = document.querySelector("#" + scrollId);
            load(target);
        });
    };

    var links = document.querySelectorAll("a[href^='#']:not([href='#'])");

    /* Проходимся по всем элементам, у которых в href есть хэш */
    Array.prototype.forEach.call(links, function (el) {
        initAnimateScroll(el);
    });

    module.callback = load;

    itsoftApp.modules.windowResize.addEvent(getViewportSize);
});